import React, {useEffect, useState} from "react";
import {useRouter} from "next/router";
import store from "../store";
import shopApi from "../api/shop";
import {MetaWrapper} from "../components/MetaWrapper";
import {useSelector} from "react-redux";
import generalAction from "../api/generalAction";
import defaultPicture from '../images/defaultpic.webp'
import dynamic from "next/dynamic";
import {IState} from "../types/state";
import {IProductInnerPage} from "../types/productPageTypes";
import {GetServerSideProps} from "next";
import allActions from "../services/actionsArray";
import {getSeparateDomain} from "../services/utils";
import {domainUrl} from "../helper";
import SettingsController from "../controllers/SettingsController";


const ShopPageProduct = dynamic(() => import('../components/shop/ShopPageProduct'))


const ProductInnerPage: React.FC<IProductInnerPage> = (props: IProductInnerPage) => {
    const {
        relatedProducts,
        serverSideProduct,
        locale,
        productSlug,
        rate,
        dispatches,
        currencies,
        configurableVariantes,
        bundle,
        metas,
        getBuilderData,
        translations,
        dbName,
        domain
    } = props

    const {
        product_flat: [{
            meta_title = "",
            meta_keywords = "",
            meta_description = "",
            name = "",
            url_key= "",
            short_description = ""
        } = {}],
        yoast_products: [{
            yoast_facebook_description = "",
            yoast_facebook_title = "",
            yoast_twitter_description = "",
            yoast_twitter_title = "",
            yoast_focus_keyword = ""
        } = {}],
        product_images: [{ path = "" } = {}],
        id: productId,
        type: productType
    } = serverSideProduct || {};

    const checkRelatedProducts = relatedProducts?.filter(
        (item: any) => item.product_flat[0]?.product_id !== productId
    );

    const [product, setProduct] = useState(serverSideProduct);
    const [changes, setChanges] = useState(false);
    const {dispatch} = store;
    let imgObj: any = {
        large_image_url: defaultPicture.src,
        medium_image_url: defaultPicture.src,
        original_image_url: defaultPicture.src,
        path: defaultPicture.src,
        small_image_url: defaultPicture.src,
        url: defaultPicture.src,
    }
    if (productType !== 'bundle' && product.product_images?.length == 0) {
        product.product_images.push(imgObj)
    }

    const router = useRouter();

    useEffect(() => {
        window.history.replaceState(null, "", window.location.pathname);
        setProduct(serverSideProduct)
        setChanges(!changes)
        router.push(window.location.pathname)
    }, [productSlug, locale, rate]);

    useEffect(() => {
        for (let actionKey in dispatches) {
            // @ts-ignore
            dispatch(allActions[actionKey](dispatches[actionKey]));
        }
    }, [locale, currencies]);

    return (
        <MetaWrapper
            dbName={dbName}
            domain={domain}
            locale={locale}
            title={!!meta_title ? meta_title : name}
            m_title={meta_title}
            m_desc={!!meta_description ? meta_description : short_description}
            m_key={meta_keywords}
            m_img={dbName && path}
            m_url={dbName && `https://${dbName}/${locale}/${url_key}`}
            FB_desc={yoast_facebook_description}
            FB_title={yoast_facebook_title}
            TW_desc={yoast_twitter_description}
            TW_title={yoast_twitter_title}
            y_keyword={yoast_focus_keyword}
        >
            <ShopPageProduct
                rate={rate}
                layout="standard"
                productSlug={productSlug}
                relProduct={checkRelatedProducts}
                productData={product}
                configurableVariantes={configurableVariantes}
                locale={locale}
                loading={true}
                changes={changes}
                bundle={bundle}
                dbName={dbName}
                currencies={currencies}
                sidebarPosition={"undefined"}
                domain={""}
                getBuilderData={getBuilderData}
                translations={translations}
            />
        </MetaWrapper>
    );
}
export default ProductInnerPage

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
    const {locale, req, query} = ctx
    let selectedCurrency: string = '';
    let selectedRate;
    const dbName = req.headers["x-forwarded-host"];
    const domain = getSeparateDomain(dbName)
    ///////FIXME WE HAVE PROBLEM WITH RELETED PRODUCTS PRICE WITH CURENCY
    const {productSlug} = query;
    ////CHECKING CURRENCY
    if (Object.keys(req.query).length > 0) {
        selectedCurrency = req.query.currencies;
    }
    const generalOptions = {
        locale,
        selectedCurrency,
        dbName
    }

    const {
        locale: defaultLocaleSelected,
        rate,
        currency,
        dispatches
    } = await generalAction.action("general", generalOptions, req.m)

    ////GETTING RATE FOR CURRENCY
    if (Object.keys(req.query).length > 0) {
        selectedRate = rate.currencies_new?.find(
            (item: any) => item.code == selectedCurrency
        );
    }

    const selectedLocale = locale !== "catchAll" ? locale : defaultLocaleSelected;


    /********** async request [productBySlug] **********/

    const product = await shopApi.getProductBySlugAsync(productSlug, {
        locale: selectedLocale,
        // selectedRate: selectedRate?.exchange_rate.rate || 1,
    }, req.m);


    if (product?.notFound) {
        return {
            notFound: true
        }
    }

    /********** async request [relatedProducts] **********/

    const relOptions = {
        category_id: product[0]?.categories[0]?.category_id,
        product_id: product[0]?.id,
        locale: selectedLocale,
        currency: selectedRate,
        limit: 8,
        // selectedRate: selectedRate?.exchange_rate.rate || 1,
    }
    const relatedProducts = await shopApi.getRelatedProductsAsync(relOptions, req.m);
    const metaTags = await shopApi.getHomeMetaAsync(domain, selectedLocale, req.m);
    const getBuilderData = await shopApi.getBuilderDataAsync(product[0]?.id + 200, domain, selectedLocale, req.m)
    let configurabelConfigProduct = null;
    let bundleProduct = null;
    // if (product[0].type === "configurable") {
    //     const configurableId =  product[0].id;
    //     configurabelConfigProduct = await shopApi.getConfigurabelConfigProductAsync(configurableId);
    // }
    /******* uncomment this part after bundle product is ready *******/
    if (product.type === "bundle") {
        const bundleId = product.parent_id || product.id;
        const bundleOptions = {
            id: bundleId,
            locale: selectedLocale,
            // selectedRate: selectedRate?.exchange_rate.rate || 1,

        }
        bundleProduct = await shopApi.getBundleProductAsync(bundleOptions, req.m);
    }
    const generalDispatches: any = {
        ...dispatches.clientSide,
        ...dispatches.serverSide,
    };

    const translations = await SettingsController.Get_Translations(selectedLocale, req.m);

    const coreConfigs = await shopApi.getCoreConf(selectedLocale, req.m);
    const getLocales = await shopApi.getLocale(selectedLocale, req.m)
    let arrFooterTrack = [];
    let showSubFooter = "none";
    let isBlogActive = false;

    if (coreConfigs.sales_tracking_tracking_active?.value === "1" || !coreConfigs.hasOwnProperty("sales_tracking_tracking_active")) {
        arrFooterTrack.push({href: "/tracking", id: "tracking", defaultMessage: "Tracking Number"})
    }
    if (coreConfigs.theme_contact_us_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_contact_us_active")) {
        arrFooterTrack.push({href: "/contact", id: "contact_with_us", defaultMessage: "Contact With Us"})
    }
    if (coreConfigs.theme_subscription_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_subscription_active")) {
        showSubFooter = "block";
    }
    if (coreConfigs.theme_blog_active?.value === "1" || !coreConfigs.hasOwnProperty("theme_blog_active")) {
        isBlogActive = true;
    }
    const footerContent = coreConfigs.general_content_footer_footer_content?.find((item: any) => item?.locale_code === selectedLocale);

    const { general_content_custom_scripts_custom_javascript, general_content_custom_scripts_custom_css } = coreConfigs || {};
    const { value: customScriptAnalyze } = general_content_custom_scripts_custom_javascript || {};
    const { value: customCssAnalyze } = general_content_custom_scripts_custom_css || {};

    return {
        props: {
            locale: selectedLocale,
            dispatches: generalDispatches,
            rate: selectedRate?.exchange_rate.rate || 1,
            currencies: selectedCurrency || null,
            productSlug: productSlug,
            serverSideProduct: product[0] || {},
            relatedProducts: relatedProducts,
            configurableVariantes: [],
            bundle: bundleProduct ? bundleProduct[0][0] : [],
            dbName,
            domain: domain,
            metas: metaTags,
            currency,
            getBuilderData,
            translations: translations[selectedLocale].translations,
            topBarLocales: getLocales[0].locales,
            hasTracking: arrFooterTrack,
            footerContent: footerContent ?? null,
            showSubscription: showSubFooter ?? null,
            isBlogActive: isBlogActive,
            customScriptAnalyze: customScriptAnalyze ?? null,
            customCssAnalyze: customCssAnalyze ?? null,
        },
    };
}
